/* eslint-disable no-use-before-define */
/* eslint-disable no-console */
import { of } from "rxjs";
import {
  distinctUntilChanged,
  filter,
  map,
  tap,
  switchMap,
  catchError,
} from "rxjs/operators";
import noop from "lodash/noop";
import store$ from "./storeListener";
import apiClient from "./apiClient";
import AddToast from "../state/actions/AddToast";
import store from "../state/store";

function getVariantResultInfo() {
  const { chromosome: c, pos: p, ref: r, alt: a } = store$.value.variantResult;
  return {
    id: getCurrentId(),
    type: getCurrentType(),
    c,
    p,
    r: r || "0",
    a,
  };
}

function getCurrentId() {
  const { queryType, variantResult } = store$.value; // from the global store
  const { gene_id: geneId, variant_id: variantId } = variantResult || {};
  return queryType === "gene" ? String(geneId) : String(variantId);
}

function getCurrentType() {
  return store$.value.queryType === "gene" ? "gene" : "variant";
}

const flagService = (() => {
  let isRegistered = false;

  function register() {
    function storeDispatchFlags(flags) {
      store.dispatch({
        type: "SET_VARIANT_FLAGS",
        variantFlags: flags,
        userFlag: flags.filter((x) => x.user_flag).pop(),
      });
    }

    function handleGetFlagsError() {
      storeDispatchFlags([]);
      AddToast("Error while getting flags");
    }

    /* Listen to glabal store, whenever store updates perform workflow inside pipe. */
    store$ // whenever global store updates this will emit a new value that will go down the pipe.
      .pipe(
        map(() => getCurrentId()), // map: take the store and map it to the id of either variant or gene id
        filter(Boolean),
        distinctUntilChanged(), // if the id is the same stop propagation (we have already fetched flags for id)
        filter(() => store$.value && store$.value.variantResult),
        map(() => getVariantResultInfo()),
        tap(() => storeDispatchFlags([])),
        switchMap((d) => apiClient.getFlags(d.type, d.id, d.c, d.p, d.r, d.a)),
        filter(Boolean),
        map((res) => res.flags),
        filter((flags) => Array.isArray(flags)),
        tap((flags) => storeDispatchFlags(flags)),
        catchError((e) => {
          console.log(e);
          return of(null);
        })
      )
      .subscribe(noop, handleGetFlagsError);
  }

  return {
    register: () => {
      if (!isRegistered) {
        register();
        isRegistered = true;
      }
    },
  };
})();

export default Object.freeze(flagService);
